import React, { useState, useEffect } from "react";
import moment from "moment";
import html2canvas from "html2canvas";
import ReactAudioPlayer from "react-audio-player";
import html2pdf from "html2pdf.js";

import { fileUrl, endPoints } from "../../../config";
import SideBar from "../common/sideBar";

import { GetPdfHtml } from "../../common/CampaignPdfHtml";

import {
  axiosInstnace as Axios,
  calculateAmountAndTax,
} from "../../../util/util";
import HeaderAdminpanel from "../common/HeaderAdminpanel";

//Generate the pdf for campaign
const generatePdf = async (campaign) => {
  const input = document.getElementById("divToPrint");
  input.style.display = "block";
  var opt = {
    filename: `${campaign._id}.pdf`,
  };
  await html2pdf()
    .from(input)
    .set(opt)
    .save();
  input.style.display = "none";
  // html2canvas(input)
  //   .then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF();
  //     pdf.addImage(imgData, 'JPEG', 0, 0);
  //     pdf.save(`${campaign._id}.pdf`);
  //     input.style.display= 'none';
  //   });
};

//Show campaign info
const ViewCampaign = (props) => {
  console.log("Veiw Campaing");

  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  const [campaign, setCampaign] = useState(props.campaign);
  const [audioUrl, handleAudioUrl] = useState(campaign.audioUrl);
  const [clientKYC, handleClientKYC] = useState(undefined);
  
  useEffect(()=>{
    getClientKYC();
  }, []);
  //Download Audio file
  const downladAudio = (audioUrl, audioDuration = 0) => {
    var fileName = audioUrl.split("/");
    var campaignName = campaign.name;
    var date = moment(campaign.startDate).format("DD-MM-YYYY");
    var originalFileName = campaign.fileName ? campaign.fileName : fileName[fileName.length - 1];
    var formatedFilename =
      campaignName.trim() +
      "_" +
      date +
      "_" +
      campaign.station +
      "_" +
      campaign._id +
      "_" +
      (audioDuration ? audioDuration : campaign.audioDuration) + " Seconds" +
      "_" +
      originalFileName;
    console.log(formatedFilename);
    try {
      console.log(fileName);
      Axios.get(endPoints.downloadAudio, {
        // responseType: "blob",
        params: {
          file: audioUrl,
          download: formatedFilename,
        },
      }).then((response) => {
        debugger;
        const url = response.data.url;
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", formatedFilename);
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
      console.log("Error while download audio :" + error);
    }
  };

  //Audio round off calculation
  const audioRoundOff = (bytes, decimals = 2) => {
    console.log("calculation for audion length");
    var sizes = ["Bytes", "KB", "MB", "GB"];
    if (bytes == 0) return "0 bytes";
    var dm = decimals < 0 ? 0 : decimals;
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed()) + " " + sizes[i];
  };

  let kycDetails =
    campaign && campaign.kycDetails.length > 0 ? campaign.kycDetails[0] : null;
  let userDetails =
    campaign && campaign.userDetails.length > 0
      ? campaign.userDetails[0]
      : null;
  console.log(campaign.userDetails);

  const getClientKYC = async () => {
    const clientKYCData = await Axios.get(`${endPoints.getClientKYC}?campaign=${campaign._id}`);

    if(clientKYCData.data.data && clientKYCData.data.data.clientKYC){
      handleClientKYC(clientKYCData.data.data.clientKYC)
      setCampaign({...campaign, clientKYC: clientKYCData.data.data.clientKYC });
    }
  }

  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales brands-head"
          >
            <div className="container-head print_head">
              <div className="dashboard-breadcrumb">
                Campaign Management | Campaign List |
                <span className="blue_camp"> Campaign Detail</span>
              </div>
              <div className="print_btn">
                <button onClick={() => generatePdf(campaign)}>
                  Download Campaign details
                </button>
              </div>
              {campaign.contract_file_url && (
                <div className="gstdetail">
                  <div className="download_gst">
                    {campaign.contract_file_url && (
                      <div className="downloadaudio_file gst_file">
                        <a
                          href={
                            campaign.contract_file_url
                              ? `${campaign.contract_file_url}`
                              : ""
                          }
                          download
                          target="__blank"
                        >
                          Download Contract
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {campaign.traffic_order_file_url && (
                <div className="gstdetail">
                  <div className="download_gst">
                    {campaign.traffic_order_file_url && (
                      <div className="downloadaudio_file gst_file">
                        <a
                          href={
                            campaign.traffic_order_file_url
                              ? `${campaign.traffic_order_file_url}`
                              : ""
                          }
                          download
                          target="__blank"
                        >
                          Download Traffic Order
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="camplist_detail_wrapper">
              <div className="camplist_detail_left">
                <div className="camplist_left_inner">
                  <div className="camplist_data">
                    <span className="camplist_head">Campaign Name</span>
                    <span className="camplist_name">{campaign.name}</span>
                  </div>
                  <div className="camplist_data">
                    <span className="camplist_head">Brand Name</span>
                    <span className="camplist_name">{campaign.brand}</span>
                  </div>
                  <div className="camplist_data">
                    <span className="camplist_head">Product Category</span>
                    <span className="camplist_name">{campaign.product}</span>
                  </div>
                </div>
                <div className="camplist_left_inner">
                  <div className="camplist_data">
                    <span className="camplist_head">Package Type</span>
                    <span className="camplist_name">{campaign.type}</span>
                  </div>
                  <div className="camplist_data">
                    <span className="camplist_head">Days Count</span>
                    <span className="camplist_name">{campaign.days}</span>
                  </div>
                  <div className="camplist_data">
                    <span className="camplist_head">Start Date</span>
                    <span className="camplist_name">
                      {moment(campaign.startDate).format("DD/MM/YYYY")}
                    </span>
                  </div>
                </div>
                {campaign.type === "Rotation Based" && campaign.isMultiDurationAudio != 'true' && (
                  <div className="camplist_left_inner">
                    <div className="camplist_data">
                      <span className="camplist_head">Rotation Per Day</span>
                      <span className="camplist_name">
                        {campaign.rotationPerDay}
                      </span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Station</span>
                      <span
                        className="camplist_name"
                        style={{ wordWrap: "break-word" }}
                      >
                        {campaign.station}
                      </span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Audio Duration</span>
                      <span className="camplist_name">
                        {campaign.audioDuration &&
                          campaign.audioDuration.toFixed(0)}
                      </span>
                    </div>
                  </div>
                )}
                  <div className="camplist_left_inner">
                  {campaign.bookingType && (

                    <div className="camplist_data">
                      <span className="camplist_head">Time Band </span>{" "}
                      <span
                        className="camplist_name"
                        style={{ textTransform: "capitalize" }}
                      >
                        {campaign.bookingType}{" "}
                      </span>{" "}
                    </div>)}
                    {campaign.language && 
                    <div className="camplist_data">
                      <span className="camplist_head">Audio Language</span>{" "}
                      <span className="camplist_name">{campaign.language}</span>{" "}
                    </div>}
                    {campaign.timebands && (
                      <div className="camplist_data">
                        <span className="camplist_head">Selected Bands </span>{" "}
                        <span className="camplist_name">
                          {campaign.timebands}{" "}
                        </span>{" "}
                      </div>
                    )}
                  </div>

                <div className="camplist_left_inner">
                  <div className="camplist_data">
                    <span className="camplist_head">
                      What is the objective of your campaign ?
                    </span>
                    <span className="camplist_name">{campaign.objective}</span>
                  </div>
                  <div className="camplist_data">
                    <span className="camplist_head">Audio Uploaded By</span>
                    <span className="camplist_name">
                      {campaign.bigFmAudio ? "User" : "BigFM"}
                    </span>
                  </div>
                  <div className="camplist_data">
                    <span className="camplist_head">Campaign ID</span>
                    <span className="camplist_name">{campaign._id}</span>
                  </div>
                </div>
                {campaign.type === "Frequency Based" && (
                  <div className="camplist_left_inner">
                    <div className="camplist_data">
                      <span className="camplist_head">Station</span>
                      <span
                        className="camplist_name"
                        style={{ wordWrap: "break-word" }}
                      >
                        {campaign.station}
                      </span>
                    </div>

                    {/*<div className="camplist_data">*/}
                    {/*<span className="camplist_head">Audio Duration</span>*/}
                    {/*<span className="camplist_name">{campaign.audioDuration}</span>*/}
                    {/*</div>*/}
                  </div>
                )}
                <div className="camplist_left_inner">
                  <div className="camplist_data">
                    <span className="camplist_head">Payment Status</span>
                    <span className="camplist_name">
                      {campaign.pendingAmount && campaign.pendingAmount > 0
                        ? "Payment Pending"
                        : "Payment Completed"}
                    </span>
                  </div>

                  {campaign && campaign.payId && !campaign.payId_1 && (
                    <div className="camplist_data">
                      <span className="camplist_head">Payment Id</span>
                      <span className="camplist_name">{campaign.payId}</span>
                    </div>
                  )}
                  {campaign && campaign.payId_1 && campaign.payId && (
                    <div className="camplist_data">
                      <span className="camplist_head">Split Payment Ids</span>
                      <span className="camplist_name">
                        {campaign.payId}, {campaign.payId_1}
                      </span>
                    </div>
                  )}
                  {campaign && campaign.sallerId && (
                    <div className="camplist_data">
                      <span className="camplist_head">
                        Sales Representive ID
                      </span>
                      <span className="camplist_name">
                        {campaign.sallerId}{" "}
                      </span>
                    </div>
                  )}
                </div>
                {campaign.audioUrl &&
                  (!campaign.audioUrls || campaign.audioUrls.length == 1) && (
                    <div className="camplist_data">
                      <span className="camplist_head">Uploaded Audio File</span>
                      <div className="camplist_name">
                        <div className="audio_inner">
                          <div className="audio_img">
                            <img src="../../assets/images/song.svg" />
                          </div>
                          <div className="file_desc">
                            <div className="file_name_size">
                              <div className="file_name">
                                {campaign.fileName}
                              </div>
                              <span className="file_size">
                                {campaign.fileSize
                                  ? audioRoundOff(campaign.fileSize)
                                  : ""}
                              </span>
                              {/* <span className="file_size">{campaign.audioDuration}</span> */}
                            </div>
                            <div className="downloadaudio_file">
                              <button style={{color: "white"}} onClick={() => downladAudio(audioUrl)}>
                                Download
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                {!campaign.audioUrl &&
                  campaign.audioUrls &&
                  campaign.audioUrls.length > 0 && (
                    <div className="camplist_data">
                      <span className="camplist_head">
                        Uploaded Audio Files
                      </span>
                      {campaign.audioUrls.map((audio) => {
                        return (
                          <div className="camplist_name">
                            <div className="audio_inner">
                              <div className="audio_img">
                                <img src="../../assets/images/song.svg" />
                              </div>
                              <div className="file_desc">
                                <div className="file_name_size">
                                  <div className="file_name">
                                    {
                                      audio.split("/")[
                                        audio.split("/").length - 1
                                      ]
                                    }
                                  </div>
                                  <span className="file_size">
                                    {campaign.fileSize
                                      ? audioRoundOff(campaign.fileSize)
                                      : ""}
                                  </span>
                                  {/* <span className="file_size">{campaign.audioDuration}</span> */}
                                </div>
                                <div className="downloadaudio_file">
                                  <button style={{color: "white"}} onClick={() => downladAudio(audio)}>
                                    Download
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                {campaign.isMultiDurationAudio == 'true' ? (
                      <div style={{marginTop: "1em", marginBottom: "1em"}}>
                        <h3 style={{marginTop: "1em", marginBottom: "1em"}}>Selected Multi Duration Audio details</h3>
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Audio File Name</th>
                              <th>Audio Length</th>
                              <th>Number of Days</th>
                              <th>Rotations per Day</th>
                              <th>Audio</th>
                              <th>Download Audio</th>
                            </tr>
                          </thead>
                          <tbody>
                          {campaign.multidurationAudioDetail.map((audio) => {
                            return (
                              <tr>
                                <td>{audio.audio}</td>
                                <td>{audio.audioLength} Seconds</td>
                                <td>{audio.numberOfDays}</td>
                                <td>{audio.rotationsPerDay}</td>
                                <td>
                                  <div className="campviewlist_left_audio_player">
                                    <ReactAudioPlayer
                                      src={audio.src}
                                      controls
                                      controlsList="nodownload"
                                    />
                                  </div>{" "}
                                </td>
                                <td>
                                  <div className="downloadaudio_file" style={{display: "flex", justifyContent: "center"}}>
                                    <button style={{ color: "white", position: "relative" }} onClick={() => downladAudio(audio.audioDetail.Key, audio.audioLength)}>
                                      Download
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                          </tbody>
                        </table>
                      </div>
                    ): ''}
                <div className="gst_detail">
                  <h2 className="campview-detail_header gst_detail_header">
                    User Details
                  </h2>
                  <div className="gst_detail_inner">
                    <div className="gstdetail">
                      <span>User Name</span>
                      <span>{userDetails ? userDetails.name : ""}</span>
                    </div>
                    <div className="gstdetail">
                      <span>Company</span>
                      <span>{userDetails ? userDetails.company : ""}</span>
                    </div>

                    <div className="gstdetail">
                      <span>Email</span>
                      <span>{userDetails ? userDetails.email : ""}</span>
                    </div>

                    {userDetails && userDetails.mobile && (
                      <div className="gstdetail">
                        <span>Contact No.</span>
                        <span>{userDetails ? userDetails.mobile : ""}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="gst_detail">
                  <h2 className="campview-detail_header gst_detail_header">
                    Billing Address
                  </h2>
                  <div className="gst_detail_inner">
                    {((kycDetails && kycDetails.billing_Address) ||
                      (userDetails && userDetails.communication)) && (
                      <div className="gstdetail">
                        <span>Billing Address</span>
                        <span>
                          {kycDetails && kycDetails.billing_Address
                            ? kycDetails.billing_Address
                            : userDetails && userDetails.communication
                            ? `${userDetails.communication.address.plot}, ${userDetails.communication.address.street}, ${userDetails.city}, ${userDetails.state}- ${userDetails.communication.pincode}`
                            : ""}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="gstdetail">
                  <span>Billing Address Proof</span>
                  <div className="download_gst">
                    {kycDetails && kycDetails.bill_address_cert_file && (
                      <div className="downloadaudio_file gst_file">
                        <a
                          href={
                            kycDetails && kycDetails.bill_address_cert_file
                              ? `${kycDetails.bill_address_cert_file}`
                              : ""
                          }
                          download
                          target="__blank"
                        >
                          Download Proof
                        </a>
                      </div>
                    )}
                    {userDetails && userDetails.uploadeddocuments && (
                      <div className="downloadaudio_file gst_file">
                        <a
                          href={userDetails.uploadeddocuments.addressproof}
                          download
                          target="__blank"
                        >
                          Download Proof
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                {/* //vj pan */}
                <div className="gst_detail">
                  <h2 className="campview-detail_header gst_detail_header">
                    PAN Details
                  </h2>
                  <div className="gst_detail_inner">
                    <div className="gstdetail">
                      <span>PAN Number</span>
                      <span>
                        {kycDetails
                          ? kycDetails.pan_number
                          : userDetails && userDetails.kycdetails
                          ? userDetails.kycdetails.pannumber
                          : ""}
                      </span>
                    </div>

                    <div className="gstdetail">
                      <span>PAN Certificate</span>
                      <div className="download_gst">
                        {/* <span>{(kycDetails && kycDetails.pan_card_cert_file)?
                                kycDetails.pan_card_cert_file.slice(kycDetails.pan_card_cert_file.lastIndexOf('/')+ 1): ""}</span> */}
                        {kycDetails && kycDetails.pan_card_cert_file && (
                          <div className="downloadaudio_file gst_file">
                            <a
                              href={
                                kycDetails && kycDetails.pan_card_cert_file
                                  ? `${kycDetails.pan_card_cert_file}`
                                  : ""
                              }
                              download
                              target="__blank"
                            >
                              Download Certificate
                            </a>
                          </div>
                        )}
                        {userDetails && userDetails.uploadeddocuments && (
                          <div className="downloadaudio_file gst_file">
                            <a
                              href={userDetails.uploadeddocuments.pan}
                              download
                              target="__blank"
                            >
                              Download Certificate
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gst_detail">
                  <h2 className="campview-detail_header gst_detail_header">
                    GST Details
                  </h2>
                  <div className="gst_detail_inner">
                    <div className="gstdetail">
                      <span>GST Number</span>
                      <span>
                        {kycDetails
                          ? kycDetails.gst_Number
                          : userDetails && userDetails.kycdetails
                          ? userDetails.kycdetails.gstnumber
                          : ""}
                      </span>
                    </div>

                    <div className="gstdetail">
                      <span>GST Address</span>
                      <span>{kycDetails ? kycDetails.gst_Address : ""}</span>
                    </div>

                    <div className="gstdetail">
                      <span>GST Certificate</span>
                      <div className="download_gst">
                        {/* <span>{(kycDetails && kycDetails.gst_Certificate_file)?
                                kycDetails.gst_Certificate_file.slice(kycDetails.gst_Certificate_file.lastIndexOf('/')+ 1): ""}</span> */}
                        {kycDetails && kycDetails.gst_Certificate_file && (
                          <div className="downloadaudio_file gst_file">
                            <a
                              href={
                                kycDetails && kycDetails.gst_Certificate_file
                                  ? `${kycDetails.gst_Certificate_file}`
                                  : ""
                              }
                              download
                              target="__blank"
                            >
                              Download Certificate
                            </a>
                          </div>
                        )}
                        {userDetails &&
                          userDetails.uploadeddocuments &&
                          userDetails.uploadeddocuments.gst && (
                            <div className="downloadaudio_file gst_file">
                              <a
                                href={userDetails.uploadeddocuments.gst}
                                download
                                target="__blank"
                              >
                                Download Certificate
                              </a>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                
                { clientKYC && (
                  <div className="gst_detail" style={{ border: "1px solid grey", margin: "2em 0px", padding: "1em" }}>
                    <h3>Client KYC Details</h3>
                    <br/>
                    <div className="gst_detail_inner campview-detail_header gst_detail_header">
                      <div className="gstdetail">
                        <span className="campviewlist_head">
                          {" "}
                          Name{" "}
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {clientKYC.name}{" "}
                        </span>{" "}
                      </div>

                      <div className="gstdetail">
                        <span className="campviewlist_head">
                          {" "}
                          Email{" "}
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {clientKYC.emailId}{" "}
                        </span>{" "}
                      </div>
                    </div>
                    <div className="gst_detail_inner campview-detail_header gst_detail_header">
                      <div className="gstdetail">
                        <span className="campviewlist_head">
                          {" "}
                          PAN{" "}
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {clientKYC.kycdetails.pannumber}{" "}
                        </span>{" "}
                      </div>

                      <div className="gstdetail">
                        <span className="campviewlist_head">
                          {" "}
                          GST{" "}
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {clientKYC.kycdetails.gstnumber}{" "}
                        </span>{" "}
                      </div>
                      
                      <div className="gstdetail">
                        <span className="campviewlist_head">
                          {" "}
                          Billing Address{" "}
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {clientKYC.kycdetails.billingaddress}{" "}
                        </span>{" "}
                      </div>
                    </div>
                    <div className="gst_detail_inner campview-detail_header gst_detail_header">
                      <div className="gstdetail">
                        <div className="downloadaudio_file gst_file">
                          <a
                            href={
                              clientKYC.uploadeddocuments.pan
                                ? `${clientKYC.uploadeddocuments.pan}`
                                : ""
                            }
                            download
                            target="__blank"
                          >
                            Download PAN{" "}
                          </a>{" "}
                        </div>
                      </div>

                      <div className="gstdetail">
                        <div className="downloadaudio_file gst_file">
                          <a
                            href={
                              clientKYC.uploadeddocuments.gst
                                ? `${clientKYC.uploadeddocuments.gst}`
                                : ""
                            }
                            download
                            target="__blank"
                          >
                            Download GST{" "}
                          </a>{" "}
                        </div>
                      </div>
                      
                      <div className="gstdetail">
                        <div className="downloadaudio_file gst_file">
                          <a
                            href={
                              clientKYC.uploadeddocuments.addressproof
                                ? `${clientKYC.uploadeddocuments.addressproof}`
                                : ""
                            }
                            download
                            target="__blank"
                          >
                            Download Address Proof{" "}
                          </a>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="package_includes_wrapper">
                  {campaign.fctperDay > 0 &&
                    campaign.secondages > 0 &&
                    campaign.additionalBenefits > 0 &&
                    campaign.packageDiscountedCost > 0 && (
                      <div>
                        {" "}
                        <h3>Package Includes :</h3>
                        <p>
                          {campaign.fctperDay} Seconds Per Day I{" "}
                          {campaign.secondages} Total Secondages I Total Cost:{" "}
                          {campaign.totalCost} INR I Net Rate per 10secs:{" "}
                          {(
                            (campaign.packageCost / campaign.secondages) *
                            10
                          ).toFixed(2)}
                          INR I Additional Benefit:{" "}
                          {campaign.additionalBenefits} % I Discounted Cost:{" "}
                          {campaign.packageDiscountedCost} INR{" "}
                        </p>
                        { campaign.nonFCT && campaign.nonFCT[0] && (
                          <div>
                            <br/>
                            <h3> NON FCT Addons: </h3>{" "}
                            <p>{campaign.nonFCT[0].description}</p>
                          </div>
                        )}
                      </div>
                    )}
                  {campaign.secondages > 0 &&
                    campaign.additionalBenefits > 0 &&
                    campaign.packageDiscountedCost > 0 && (
                      <div>
                        {" "}
                        <h3>Package Includes :</h3>
                        <p>
                          {campaign.secondages} Total Secondages I Total Cost:{" "}
                          {campaign.totalCost} INR I Net Rate per 10secs:{" "}
                          {(
                            (campaign.packageCost / campaign.secondages) *
                            10
                          ).toFixed(2)}{" "}
                          INR I Additional Benefit:{" "}
                          {campaign.additionalBenefits} % I Discounted Cost:{" "}
                          {campaign.packageDiscountedCost} INR{" "}
                        </p>
                      </div>
                    )}
                </div>
              </div>
              <div className="camplist_detail_right">
                <div className="camplist_cost_card">
                  <h5>Campaign Cost</h5>
                  <ul className="camplist_cost_list">
                    {campaign.packageCost !== campaign.actualpackageCost && (
                      <li className="camplist_list_inner">
                        <div className="camplist_type">Actual Package Cost</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../assets/images/rupee-indian.svg" />

                          <span className="cost_inner">
                            {campaign.actualpackageCost}
                          </span>
                        </div>
                      </li>
                    )}
                    {campaign.couponDiscount > 0 && (
                      <li className="camplist_list_inner">
                        <div className="camplist_type coupon">
                          Coupon Discount
                          {campaign.couponPercentage > 0 && (
                            <span className="discount_desc">
                              Coupon Applied Flat {campaign.couponPercentage} %
                              OFF
                            </span>
                          )}
                        </div>
                        <div className="camplist_rupee_symb">
                          <img src="../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">
                            {campaign.couponDiscount}
                          </span>
                        </div>
                      </li>
                    )}
                    {
                      <li className="camplist_list_inner">
                        <div className="camplist_type">Package Cost</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../assets/images/rupee-indian.svg" />

                          <span className="cost_inner">
                            {campaign.packageCost}
                          </span>
                        </div>
                      </li>
                    }

                    <li className="camplist_list_inner">
                      <div className="camplist_type">Package Tax @18%</div>
                      <div className="camplist_rupee_symb">
                        <img src="../../assets/images/rupee-indian.svg" />
                        <span className="cost_inner">
                          {campaign.packageTax}
                        </span>
                      </div>
                    </li>
                    {campaign.audioTotalCost > 0 && (
                      <React.Fragment>
                        <li className="camplist_list_inner">
                          <div className="camplist_type">Audio Cost</div>
                          <div className="camplist_rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">
                              {campaign.audioTotalCost}
                            </span>
                          </div>
                        </li>
                        <li className="camplist_list_inner">
                          <div className="camplist_type">Audio Tax @18%</div>
                          <div className="camplist_rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">
                              {campaign.audioTax}
                            </span>
                          </div>
                        </li>
                      </React.Fragment>
                    )}
                    {campaign.audioRefundAmount > 0 && (
                      <li className="camplist_list_inner">
                        <div className="camplist_type">Audio Discount</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">
                            {campaign.audioRefundAmount}
                          </span>
                        </div>
                      </li>
                    )}
                    { campaign.nonFCTCodeAmount > 0 && (
                        <li className="camplist_list_inner">
                          <div className="camplist_type">Non FCT Amount</div>
                          <div className="camplist_rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">
                              {campaign.nonFCTCodeAmount}
                            </span>
                          </div>
                        </li>
                      )}
                    {campaign.nonFCTCodeAmountTax &&
                      campaign.nonFCTCodeAmountTax > 0 && (
                        <li className="camplist_list_inner">
                          <div className="camplist_type">Non FCT Tax @18</div>
                          <div className="camplist_rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">
                              {campaign.nonFCTCodeAmountTax}
                            </span>
                          </div>
                        </li>
                      )}

                    <div className="totalcost">
                      <div className="camplist_type ">Total Cost</div>
                      <div className="camplist_rupee_symb">
                        <img src="../../assets/images/rupee-indian_white.svg" />
                        <span className="cost_inner">{campaign.totalCost}</span>
                      </div>
                    </div>

                    <div>
                      {campaign.audioCost > 0 && campaign.pendingAmount > 0 && (
                        <ul className="camp_cost_list">
                          <h5 className="camp_pay_now">Amount Paid</h5>

                          <li className="camplist_list_inner">
                            <div className="camplist_type">
                              Audio cost + Taxes
                            </div>
                            <div className="camplist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {campaign.audioTotal}
                              </span>
                            </div>
                          </li>
                        </ul>
                      )}
                      {campaign.audioCost > 0 && campaign.pendingAmount > 0 && (
                        <ul className="camp_cost_list">
                          <h5 className="camp_pay_now">Amount to be Paid </h5>

                          <li className="camplist_list_inner">
                            <div className="camplist_type">Package + Taxes</div>
                            <div className="camplist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {campaign.packageTotal}
                              </span>
                            </div>
                          </li>
                          {campaign.nonFCTCodeAmountTotal && campaign.nonFCTCodeAmountTotal> 0 &&   <li className="camplist_list_inner">
                            <div className="camplist_type">Non FCT+ Taxes</div>
                            <div className="camplist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {campaign.nonFCTCodeAmountTotal}
                              </span>
                            </div>
                          </li>}
                                                    {campaign.nonFCTCodeAmountTotal && campaign.nonFCTCodeAmountTotal> 0 &&   <li className="camplist_list_inner">
                            <div className="camplist_type">Total amount</div>
                            <div className="camplist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {campaign.packageTotal + campaign.nonFCTCodeAmountTotal}
                              </span>
                            </div>
                          </li>}

                        </ul>
                      )}
                    </div>
                  </ul>
                </div>
                <div className="view-btn_wrapper">
                  <button
                    className="viewdetail_back"
                    onClick={() => {
                      props.handleBack();
                    }}
                  >
                    BACK
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <GetPdfHtml campaign={campaign} />
    </div>
  );
};

export default ViewCampaign;



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/viewCampaign.js